// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"compass-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M14.1007 9.89929L12 2L9.89929 9.89929L2 12L9.89929 14.1007L12 22L14.1007 14.1007L22 12L14.1007 9.89929Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12L14.1007 9.89929L12 2M22 12L14.1007 14.1007L12 22M12 22C6.47715 22 2 17.5228 2 12M12 22L9.89929 14.1007L2 12M2 12C2 6.47715 6.47715 2 12 2M2 12L9.89929 9.89929L12 2M13.1111 11.9998C13.1111 12.6134 12.6137 13.1109 12 13.1109C11.3864 13.1109 10.8889 12.6134 10.8889 11.9998C10.8889 11.3861 11.3864 10.8887 12 10.8887C12.6137 10.8887 13.1111 11.3861 13.1111 11.9998Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-compass-1')
export default class Compass1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'compass-1',
    }
  }
}
